import { Axios } from '@src/app/context/Api/includes/Axios';
import { _translateCriteriaFilters } from '@src/entities/ActionPath/includes/functions';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isNil } from 'lodash';

/**
 * GetCommonCriteria
 *
 * @TODO Needs description.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const GetCommonCriteria = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': `/criteria/${thePayload?.id}`,
      },
      method: 'GET',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    if (!isNil(remoteResponse?.data?.activeCommonCriteriaVersion?.criteria)) {
      remoteResponse.data.activeCommonCriteriaVersion.criteria = _translateCriteriaFilters(
        remoteResponse?.data?.activeCommonCriteriaVersion?.criteria,
        'incoming'
      );
    }

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/Criteria/api/requests/queries/GetCommonCriteria.js -> GetCommonCriteria()',
      false,
      error
    );

    throw error;
  }
};
